import React from 'react';
import Row from "@prism/row";
import Tire from './Tire';
import {updateTire} from "../../../actions/conditionActions";
import {connect} from "react-redux";
import update from "immutability-helper";
import {TIRE_LOCATIONS} from "../../../utils/constants";
import Accordion from 'react-bootstrap/Accordion';
import snakeCase from "lodash.snakecase";

class Tires extends React.Component {
    state = {
        validTires: []
    };

    componentDidMount() {
        const validTires = this.props.condition.tires.filter(this.isValid);
        this.setState({validTires});
        window.scrollTo(0, 0);
    }

    getTireByLocation = (location) => {
        const conditionTire = this.props.condition.tires.find(tire => tire.location === location);
        if (conditionTire) {
            const tireIndex = this.state.validTires.findIndex(vt => vt.location === conditionTire.location);
            if (this.isValid(conditionTire) && tireIndex === -1) {
                this.updateValidTireList(conditionTire);
            }
        }
        return conditionTire;
    };

    updateTire = (tire) => {
        this.updateValidTireList(tire);
        this.props.updateTire(tire);
    };

    updateValidTireList = (tire) => {
        const tireIndex = this.state.validTires.findIndex(validTire => validTire.location === tire.location);
        if (this.isValid(tire)) {
            const updatedValidTires = tireIndex === -1
                ? update(this.state, {validTires: {$push: [tire]}})
                : update(this.state, {validTires: {[tireIndex]: {$set: tire}}});
            this.setState(updatedValidTires);
        } else if (tireIndex !== -1) {
            const updatedValidTires = update(this.state, {validTires: {$splice: [[tireIndex, 1]]}});
            this.setState(updatedValidTires);
        }
    };

    isValid = (tire) => {
        const {manufacturer, size, construction} = tire;
        return !!manufacturer && !!size && !!construction;
    };

    render() {

        TIRE_LOCATIONS.forEach(tireLocation => {
            this.updateValidTireList(tireLocation)
        });

        return (<>
                <Row className="mx-0 mb-3 pt-3">
                    <Accordion defaultActiveKey={[0, 1, 2, 3, 4]} alwaysOpen flush>
                        {TIRE_LOCATIONS.map((tireLocation, index) => (
                            <Accordion.Item
                                eventKey={index}
                                key={`${tireLocation}-accitem`}
                            >
                                <Accordion.Header className={`${snakeCase(tireLocation)}`}>
                                    {tireLocation}
                                </Accordion.Header>
                                <Accordion.Body>
                                    <Tire
                                        tire={this.getTireByLocation(tireLocation)}
                                        updateTire={this.updateTire}
                                        validTires={this.state.validTires}
                                        key={tireLocation}
                                    />
                                </Accordion.Body>
                            </Accordion.Item>
                        ))}
                    </Accordion>
                </Row>
            </>
        )
    }
}


const mapDispatchToProps = {
    updateTire
};

function mapStateToProps({condition}) {
    return {condition};
}

export default connect(mapStateToProps, mapDispatchToProps)(Tires);